import AppLayout from "../components/layout/AppLayout";
import { ROUTES } from "../constant/routes";
import Chats from "../pages/Chats";
import MeetingRoom from "../pages/MeetingRoom";
import Poster from "../pages/Poster";
import ProfileDetails from "../pages/ProfileDetails";

const protectedRouter = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: ROUTES.CHATS,
        element: <Chats />,
      },
      {
        path: ROUTES.PROFILE,
        element: <ProfileDetails />,
      },
      {
        path: ROUTES.POSTER,
        element: <Poster />,
      },
    ],
  },
  {
    path: `${ROUTES.MEETING_ROOM}/:roomId`,
    element: <MeetingRoom />,
  },
];

export default protectedRouter;
